import UUID from 'uuid/v4';

const escapeHtml = function(text) {
	let map = {
		'&': '&amp;',
		'<': '&lt;',
		'>': '&gt;',
		'"': '&quot;',
		"'": '&#039;'
	};

	return text.replace(/[&<>"']/g, m => {
		return map[m];
	});
};

export const curView = ({ views, curViewId }) => {
	return views[curViewId];
};
export const curConversation = ({ ConversationProviders }) => {
	return ConversationProviders.curConversation;
};

export const isPluginInstalled = ({ plugins }) => pluginName => {
	return plugins.hasOwnProperty(pluginName);
};

export const isPluginReady = ({ plugins }, getters) => pluginName => {
	return getters.isPluginInstalled(pluginName) && plugins[pluginName].ready;
};

export const pluginFunctionality = ({ plugins }, getters) => functionality => {
	let activePlugins = [];

	for (let pluginName in plugins) {
		let plugin = plugins[pluginName];
		if (getters.isPluginReady(pluginName)) {
			if (plugin.functionalities.indexOf(functionality) !== -1) {
				activePlugins.push(pluginName);
			}
		}
	}

	return activePlugins;
};

export const pluginFunctionalityRenderMsgBody = (state, getters) => {
	return getters.pluginFunctionality('renderMsgBody');
};

export const renderMsgBody = ({ plugins }, getters) => msg => {
	let pluginFunctionalityRenderMsgBody =
		getters.pluginFunctionalityRenderMsgBody;

	return async () => {
		let rmsgbody = decodeURIComponent(msg.body);
		let modified = false;

		for (
			let pluginNameI = 0;
			pluginNameI < pluginFunctionalityRenderMsgBody.length;
			pluginNameI++
		) {
			let pluginName = pluginFunctionalityRenderMsgBody[pluginNameI];
			let plugin = plugins[pluginName];

			let nrmsgbody = await new Promise((resolve, reject) => {
				let resolveId = UUID();
				plugin.promise.addOnceId(resolveId, data => {
					// console.log('main resolving in renderMsgBody for', resolveId, data, pluginName, msg, rmsgbody);
					if (data.hasOwnProperty('renderMsgBody')) {
						resolve(data.renderMsgBody);
					}
				});
				plugin.worker.postMessage({
					renderMsgBody: {
						msgbody: rmsgbody,
						msg
					},
					resolveId
				});
			});

			if (nrmsgbody !== rmsgbody) {
				modified = true;
			}

			rmsgbody = nrmsgbody;
		}

		if (!modified) {
			rmsgbody = escapeHtml(rmsgbody);
		}

		return rmsgbody;
	};
};

export const resourceExtComponents = ({ plugins }, getters) => () => {
	let rcomponents = [];

	for (let pluginName in plugins) {
		let plugin = plugins[pluginName];
		if (getters.isPluginReady(pluginName)) {
			if (plugin.hasOwnProperty('resourceExts')) {
				for (let cI = 0; cI < plugin.resourceExts.length; cI++) {
					let c = plugin.resourceExts[cI];

					rcomponents.push({
						pluginName,
						componentName: c.name,
						component: c.component
					});
				}
			}
		}
	}

	return rcomponents;
};

export const inputExtComponents = ({ plugins }, getters) => () => {
	let rcomponents = [];

	for (let pluginName in plugins) {
		let plugin = plugins[pluginName];
		if (getters.isPluginReady(pluginName)) {
			if (plugin.hasOwnProperty('inputExts')) {
				for (let cI = 0; cI < plugin.inputExts.length; cI++) {
					let c = plugin.inputExts[cI];

					rcomponents.push({
						pluginName,
						componentName: c.name,
						component: c.component
					});
				}
			}
		}
	}

	return rcomponents;
};
